export const MULTI_FIELD_SEARCH_KEY = 'multiFieldSearch';
export const LOCATION_SEARCH_KEY = 'locationSearch';
export const ONLINE_OFFERS_SEARCH_KEY = 'includeOnlineOffers';
